import type { Category } from "./type";

export const WORKERS_FOR_SELECT_PATH = "/v2/workers-for-select" as const;

export const workersForSelect = {
  all: [WORKERS_FOR_SELECT_PATH] as const,
  workers: (searchText: string, category?: Category) =>
    [...workersForSelect.all, { searchText, category }] as const,
} as const;
